import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// Real backend confirmed: getStatsByStatus() returns a flat object exactly like
// { DRAFT: 0, REGISTERED: 5, AVAILABLE: 42, ALLOCATED: 183, IN_SERVICE: 12, DISPOSED: 5 }
// This slice fetches it and reshapes it into the countCards array
// { name, count } shape that AssetList.jsx renders as stat cards.

const CARD_CONFIG = [
     { key: "TOTAL", label: "Total Assets", color: "#8c8c8c" },
     { key: "AVAILABLE", label: "Available", color: "#52c41a" },
     { key: "ALLOCATED", label: "Allocated", color: "#1890ff" },
     { key: "IN_SERVICE", label: "In Service", color: "#faad14" },
];

export const fetchAssetStats = createAsyncThunk("fetchAssetStats", async () => {
     const response = await axiosHttp.get(`assets/stats/by-status`);
     return response.data?.data ?? response.data;
});

const AssetStatsSlice = createSlice({
     name: "assetStatsSlice",
     initialState: {
          isLoading: false,
          data: null, // raw { STATUS: count } object
          error: null,
     },
     extraReducers: (builder) => {
          builder.addCase(fetchAssetStats.pending, (state) => {
               state.isLoading = true;
          });
          builder.addCase(fetchAssetStats.fulfilled, (state, action) => {
               state.isLoading = false;
               state.data = action.payload;
          });
          builder.addCase(fetchAssetStats.rejected, (state, action) => {
               state.isLoading = false;
               state.error = action.payload;
          });
     },
});

export const selectAssetCountCards = (statsData) => {
     if (!statsData) return [];
     const total = Object.values(statsData).reduce((sum, v) => sum + (v || 0), 0);
     return CARD_CONFIG.map(({ key, label, color }) => ({
          name: label,
          count: key === "TOTAL" ? total : statsData[key] ?? 0,
          color,
     }));
};

export default AssetStatsSlice.reducer;